import { render } from "./StatisticsPublicViewsCountByTimeTab.vue?vue&type=template&id=6b9b48b0&ts=true"
import script from "./StatisticsPublicViewsCountByTimeTab.vue?vue&type=script&lang=ts"
export * from "./StatisticsPublicViewsCountByTimeTab.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__